module.exports = __webpack_public_path__ + "img/GT.d95891cd.png";